import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { NewHttpClient } from '../interceptor.service';
import { INJECTION_TOKEN } from '../../app.config';

@Injectable()
export class ManagerDriverAssignmentRequests {
  constructor(
    @Inject(INJECTION_TOKEN) public config: any,
    private http: NewHttpClient
  ) {}

  /**
   * Get manager driver assignments
   *
   * @param managerId - Manager user ID
   * @returns Observable with manager assignments
   */
  getAssignments(managerId: string): Observable<any> {
    const url = `${this.config.users_base}manager-driver-assignments/${managerId}`;
    return this.http.get(url);
  }

  /**
   * Bulk assign drivers to manager
   *
   * @param managerId - Manager user ID
   * @param driverIds - Array of driver IDs
   * @returns Observable with assignment result
   */
  bulkAssign(managerId: string, driverIds: string[]): Observable<any> {
    const url = `${this.config.users_base}manager-driver-assignments/bulk`;
    return this.http.post(url, { managerId, driverIds });
  }

  /**
   * Unassign a driver from manager
   *
   * @param managerId - Manager user ID
   * @param driverId - Driver ID to unassign
   * @returns Observable with unassignment result
   */
  unassign(managerId: string, driverId: string): Observable<any> {
    const url = `${this.config.users_base}manager-driver-assignments/${managerId}/${driverId}`;
    return this.http.delete(url);
  }

  /**
   * Delete all driver assignments for a manager
   *
   * @param managerId - Manager user ID
   * @returns Observable with deletion result
   */
  deleteAll(managerId: string): Observable<any> {
    const url = `${this.config.users_base}manager-driver-assignments/${managerId}`;
    return this.http.delete(url);
  }
}
